export enum SummaryStatusType{
    NOT_TO_BE_CHARGED = 'NOT_TO_BE_CHARGED',
    DISCOUNTED_PURCHASE_PRICE = 'DISCOUNTED_PURCHASE_PRICE',
    DISCOUNTED_SELLING_PRICE = 'DISCOUNTED_SELLING_PRICE',
    PAID = 'PAID',
    REMINDED = 'REMINDED',
    CHARGED = 'CHARGED',
    NOT_CHARGED = 'NOT_CHARGED',
    MANUAL_DISCOUNT = 'MANUAL_DISCOUNT',
}
